import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { Grid } from '@mui/material'
import * as category from '../../appRedux/actions/category'
import ProductBox from '../../components/product_box'
import Loading from '../../components/loading'

function HomePage(props) {

    useEffect(() => {
        props.categoryMainAction()
    }, [])

    return (
        <React.Fragment>
            {props.loadingPage ? <Loading /> :
                <Grid container spacing={4}>
                    {props.data.map((obj , index) => (
                        <Grid key={index} item xs={6} md={3}>
                            <ProductBox dirType="dir" {...obj} />
                        </Grid>
                    ))}
                </Grid>
            }
        </React.Fragment>
    )
}

const mapStateToProps = (state) => {
    return {
        data: state.common.data,
        loadingPage: state.common.loadingPage
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        categoryMainAction: () => dispatch(category.categoryMainAction()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(HomePage)
